<template>
  <div class="a-container">
    <div class="o-card_container">
      <assistant-chat-viewer
        v-if="
          !!value.advanceSettings?.hasAssistants &&
          !!value.advanceSettings?.aiChatConfig?.assistantId
        "
        :aiChatConfig="value.advanceSettings.aiChatConfig"
      />

      <div id="Nikola_Tesla" class="o-card">
        <div
          :style="{ background: value.pallete.headColor }"
          class="o-card_header"
        >
          <v-responsive
            :aspect-ratio="16 / 9"
            :style="{ backgroundImage: `url(${getHeaderImg})` }"
            class="o-card_headerHeroImg"
          />

          <v-btn
            absolute
            dark
            depressed
            fab
            right
            small
            style="background-color: rgba(0, 0, 0, 0.45); top: 8px"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>

          <profile-photos
            v-model="value.photo"
            :size="'70px'"
            class="profTr m-2"
          />
        </div>

        <div class="o-card_body">
          <h2 class="o-card_title my-1">{{ value.organizationName }}</h2>
          <h6 class="o-card_subTitle my-1">{{ value.subOrgan }}</h6>
          <p
            :class="show ? 'o-card_paragraph isToggle' : 'o-card_paragraph'"
            class="custom-scrollbar"
          >
            {{ value.aboutUs }}
          </p>
          <span v-if="value.aboutUs.length > 100" class="a.more">
            <i v-if="show" class="icon-minus-circled" @click="showMore"></i>
            <i v-else class="icon-plus-circled" @click="showMore"></i>
          </span>
        </div>

        <v-spacer />

        <div class="o-card_footer">
          <a
            :style="{ background: value.pallete.headColor }"
            class="a-readMore"
            data-href="Nikola_Tesla"
            data-modal="#first"
            target="_blank"
            @click="toggleModal"
            >مشاهده بیشتر<i class="icon-left"></i
          ></a>
        </div>

        <div
          :class="isOpen ? 'o-modal isOpen' : 'o-modal'"
          :style="{
            background: value.pallete.bodyColor,
            color: value.pallete.textColor,
          }"
        >
          <span class="o-modal__close" @click="toggleModal">
            <i class="icon-cancel-circled"></i>
          </span>
          <h2
            :style="{ color: value.pallete.textColor }"
            class="o-modal__title mr-4"
          >
            {{ value.singleProduct.name }}
          </h2>
          <div
            :style="{ color: value.pallete.textColor }"
            class="o-modal__inner mr-4 custom-scrollbar"
          >
            <p
              v-if="value.singleProduct.price"
              :style="{ color: value.pallete.textColor }"
              class="text-right"
            >
              <span class="font-weight-bold"> <span>قیمت</span> : </span>
              <span
                :style="{
                  'text-decoration-line': value.singleProduct.discount
                    ? 'line-through'
                    : '',
                  color: value.pallete.textColor,
                }"
              >
                {{ value.singleProduct.price | currency | persianNum }} ﷼</span
              >
              <span
                v-if="computePrice"
                :style="{ color: value.pallete.textColor }"
                class="font-weight-bold float-end mr-10"
                >{{ computePrice | currency | persianNum }} ﷼</span
              >
            </p>

            <v-btn
              v-if="!!btnSetting"
              :href="btnSetting.link"
              :style="{
                background: btnSetting.background,
                color: btnSetting.color,
              }"
              class="mb-2"
              target="_blank"
            >
              <v-icon v-if="!!btnSetting.icon" left>{{
                btnSetting.icon
              }}</v-icon>
              {{ btnSetting.title }}
            </v-btn>

            <div v-if="value.singleProduct.description">
              <v-icon :color="value.pallete.textColor"
                >mdi-comment-account-outline</v-icon
              >
              :
              <span class="font-weight-bolder">درباره محصول</span>
              <div class="col-md-12 mb-2">
                <pre
                  :style="{ color: value.pallete.textColor }"
                  class="text-right my-0"
                  v-html="trancateTxts"
                />
                <v-btn
                  v-if="
                    value.singleProduct.description.length > 200 ||
                    value.singleProduct.description.split('<div>').length > 3
                  "
                  class="ms-n4"
                  color="primary"
                  text
                  @click="isTruncate = !isTruncate"
                >
                  {{ isTruncate ? "مشاهده بیشتر" : "مشاهده کمتر" }}
                </v-btn>
              </div>
            </div>
            <div v-if="hasExtra" style="max-height: 150px; overflow-y: scroll">
              <extra-shown v-model="value.singleProduct.extra" />
            </div>

            <v-card-actions
              v-if="!!value.singleProduct && !!value.singleProduct.payLink"
              class="pt-0 mt-n2 mb-2"
            >
              <v-btn
                :href="value.singleProduct.payLink"
                :style="{
                  background: value.singleProduct.btnSetting.background,
                  color: value.singleProduct.btnSetting.color,
                }"
                target="_blank"
              >
                <v-icon v-if="value.singleProduct.btnSetting.icon" class="ml-2"
                  >{{ value.singleProduct.btnSetting.icon }}
                </v-icon>
                {{ value.singleProduct.btnSetting.title }}
              </v-btn>
            </v-card-actions>

            <details-tab
              v-model="value.Features.details"
              :opened="isOpen"
              :palette="value.pallete"
            />

            <image-slider
              v-if="value.photo.gallery"
              v-model="value.photo.gallery"
            />
            <details-tab-2
              v-if="$route.name?.toLowerCase().includes('productpro')"
              v-model="value"
              :opened="isOpen"
              :palette="value.pallete"
            />

            <div
              v-if="
                value.VideoGallerySingle &&
                value.VideoGallerySingle.videos &&
                value.VideoGallerySingle.videos.length > 0
              "
            >
              <v-card
                v-for="(item, i) in value.VideoGallerySingle.videos"
                :key="i"
                class="transparent text-center"
                flat
                style="max-width: 100%"
              >
                <v-card-title
                  :class="{ 'blue--text clickable': item.link }"
                  :href="fixLink(item.link)"
                  :tag="item.link ? 'a' : 'div'"
                  class="pa-2 text-break"
                  target="_blank"
                  v-text="item.title"
                />
                <iframe :src="item.url" style="max-width: 100%; height: auto" />
                <pre v-html="item.description" />
              </v-card>
            </div>

            <div v-if="value.audiosGallery.audios.length > 0" class="pa-2">
              <v-card-title>گالری فایل صوتی</v-card-title>
              <v-row class="d-flex flex-column align-items-center">
                <v-col
                  cols="12"
                  v-for="(audio, i) in value.audiosGallery.audios"
                  :key="i"
                  class="d-flex flex-column align-items-center"
                >
                  <v-card
                    :style="{ background: audio?.background ?? 'transparent' }"
                    :color="value.pallete.bodyColor"
                    width="300"
                    class="d-flex align-items-center justify-content-center flex-column"
                  >
                    <v-card-title v-if="audio?.ti?.length > 0">{{
                      audio?.ti
                    }}</v-card-title>
                    <v-card-subtitle class="pa-0" v-if="audio?.desc?.length">{{
                      audio?.desc
                    }}</v-card-subtitle>
                    <component
                      :is="value.audiosGallery.audioType"
                      :file="audio.full_path"
                      :link="false"
                      :inf="{
                        ti: audio?.ti,
                        link: audio?.link,
                        title: audio?.title,
                        desc: audio?.desc,
                      }"
                      :image="audio?.image"
                      :title="
                        audio.title.length > 0 ? audio.title : 'فایل صوتی'
                      "
                      width="100%"
                      :height="
                        value.audiosGallery.audioType == 'newPlayer' ? 280 : 150
                      "
                      :flat="true"
                      :audioSound="false"
                      :color="audio?.color"
                      background="transparent"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <extra-shown
              v-model="value.extraFields"
              :font-color="value.pallete.textColor"
              :has-class="true"
            />

            <numbers-show
              v-model="value"
              :font-color="value.pallete.textColor"
            />

            <certificates-view v-model="value.singleProduct.arm" />
          </div>
        </div>

        <div v-if="loaderShow" class="a-loader">
          <div class="a-loader__bar"></div>
          <div class="a-loader__bar"></div>
          <div class="a-loader__bar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePhotos from "@/view/components/repeatitive/profilePhotos";
import NumbersShow from "@/view/pages/product/numbersShow";
import ExtraShown from "@/view/components/Product/extraShown";
import ImageSlider from "@/view/components/Gallery/imageSlider";
import CertificatesView from "./certificatesView";
import AudioPlayerCard from "../../components/UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer from "../../components/UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import newPlayer2 from "../../components/UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
// import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView.vue";
// import consultationNewShow from "@/view/components/consultationNew/consultationNewShow.vue";
import assistantChatViewer from "@/view/pages/qrland/components/assistantChatViewer.vue";
import detailsTab2 from "./detailsTab2.vue";
import detailsTab from "./detailsTab.vue";

export default {
  name: "productTheme2",

  components: {
    ProfilePhotos,
    CertificatesView,
    ImageSlider,
    ExtraShown,
    NumbersShow,
    AudioPlayerCard,
    newPlayer,
    newPlayer2,
    // BFeedbackView,
    // consultationNewShow,
    assistantChatViewer,
    detailsTab2,
    detailsTab,
  },

  props: {
    value: Object,
  },

  data() {
    return {
      isOpen: false,
      loaderShow: false,
      show: false,
      isTruncate: true,
    };
  },

  computed: {
    computePrice() {
      if (this.value.singleProduct.discount) {
        const percent =
          (this.value.singleProduct.price * this.value.singleProduct.discount) /
          100;
        return this.value.singleProduct.price - percent;
      } else return false;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value.socialMedia).forEach(([x, y]) => {
        extra.push(...y);
      });

      return extra;
    },
    getHeaderImg() {
      return this.value.photo.headBackground ?? "";
    },
    trancateTxts() {
      let about = this.value.singleProduct?.description;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    btnSetting() {
      return this.value.singleProduct?.btnSetting?.show
        ? this.value.singleProduct.btnSetting
        : false;
    },
    hasExtra() {
      return !!this.value.singleProduct?.extra?.some((item) => {
        delete item.type;
        return !!Object.values(item).some((s) => !!s);
      });
    },
  },

  methods: {
    toggleModal() {
      this.loaderShow = true;
      this.isOpen = !this.isOpen;
      setTimeout(() => {
        this.loaderShow = false;
      }, 1500);
    },
    showMore() {
      this.show = !this.show;
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
  },
};
</script>

<style lang="scss" scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

$primary_color: #109bce;
$secondary_color: #07526e;
$bg_body: #d4d4d4;
$white: #fff;
$black: #000;
$grey_1: #f1f1f1;
$grey_2: #f9f9f9;
$grey_3: #ccc;
$grey_4: #999;
$grey_5: #555;

@function bg_rgba($a: 1) {
  @return rgba(0, 0, 0, $a);
}

@function bg_rgba_w($a: 1) {
  @return rgba(255, 255, 255, $a);
}

@mixin border-radius($radius) {
  -webkit-border-radius: $radius;
  border-radius: $radius;
  background-clip: padding-box; /* stops bg color from leaking outside the border: */
}

@mixin abs-pos($top: auto, $right: auto, $bottom: auto, $left: auto) {
  top: $top;
  right: $right;
  bottom: $bottom;
  left: $left;
  position: absolute;
}

@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:300,400,600,700,800);
body {
  background: url(https://s3.eu-west-2.amazonaws.com/pirolab/images/grad-bg.png)
    no-repeat center (center / cover) $bg_body;
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  padding: 0;
  font-size: 95%;
  line-height: 1.2;
}

* {
  box-sizing: border-box;
}

a {
  color: $grey_5;
  font-size: 1rem;
  text-decoration: none;
  text-transform: uppercase;
}

h1 {
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  font-size: 1.6rem;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);
  font-weight: 400;
  color: $grey_4;
}

.a-container {
  min-height: 50vh;
  //width: 90%;
  //margin: 30px auto;
  //padding: 20px 0;
}

.o-card_container {
  position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row wrap;
  justify-content: space-around;

  &.isOpen {
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
}

.o-card {
  width: 100%;
  height: 70vh;
  min-width: 300px;
  background: $white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  @include border-radius(4px);
  overflow: hidden;
  //margin: 20px 0;
  display: flex;
  flex-direction: column;
  transition: all 0.4s;
  vertical-align: middle;
  position: relative;
  z-index: 1;
  padding: 0;
  align-self: center;

  &.isOpenIng {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    opacity: 0;
    z-index: 100000 !important;
  }

  &.isOpen {
    transform-origin: center top;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0 40px bg_rgba(0.3) !important;
    opacity: 1;
  }

  &::before {
    content: "";
    @include abs-pos(0, auto, auto, 50%);
    width: 0;
    height: 2px;
    background-color: $white;
    z-index: 1111;
    transition: all 0.4s;
  }
}

.a-loader {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 12000000;
  margin: 0;
  width: 100%;
  height: 6px;
  background-color: #fdba2c;
}

.a-loader__bar {
  content: "";
  display: inline;
  position: absolute;
  width: 0;
  height: 100%;
  left: 50%;
  text-align: center;
}

.a-loader__bar:nth-child(1) {
  background-color: #da4733;
  animation: loading 1s linear infinite;
}

.a-loader__bar:nth-child(2) {
  background-color: #3b78e7;
  animation: loading 1s linear 0.3s infinite;
}

.a-loader__bar:nth-child(3) {
  background-color: #fdba2c;
  animation: loading 1s linear 0.6s infinite;
}

@keyframes loading {
  from {
    left: 50%;
    width: 0;
    z-index: 100;
  }
  33.3333% {
    left: 0;
    width: 100%;
    z-index: 10;
  }
  to {
    left: 0;
    width: 100%;
  }
}

.o-modal {
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 70%);
  transition: all 1s;
  //background:rgba(255,255,255,.99);
  z-index: 1111110;
  padding: 15px;
  opacity: 0;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 10px;
    margin: 0px 0 0 -5px;
    height: 10px;
    transform-origin: center;
    background: rgba(255, 255, 255, 0.97);
    transition: all 1s;
    z-index: 1;
    border-radius: 50%;
  }

  &.isOpen {
    width: 100%;
    height: 100%;
    opacity: 1;
    left: 0;
    transform: translate(0, 0);

    &::after {
      height: 1000px;
      left: 50%;
      margin: -500px 0 0 -500px;
    }
  }
}

.o-modal__close {
  position: absolute;
  top: -1500px;
  right: 5px;
  font-size: 2rem;
  color: $grey_5;
  cursor: pointer;
  z-index: 5;
  transition: all 1s;
}

.o-modal.isOpen .o-modal__close {
  top: 5px;
}

.o-modal__title {
  font-size: 1.3rem;
  background: none;
  font-weight: 600;
  display: block;
  line-height: 1;
  margin: -15px -15px 0 -15px;
  padding: 10px 15px;
  border-bottom: 1px solid $grey_3;
  position: relative;
  z-index: 4;
  //color:white;
  //background:$grey_5;
}

.o-modal__inner {
  overflow-y: auto;
  height: calc(100% - 40px);
  opacity: 0;
  padding: 5px;
  transition: all 1.4s;
  position: relative;
  z-index: 4;
}

.o-modal.isOpen .o-modal__inner {
  opacity: 1;
  transition-delay: 1.4s;
}

.o-card_header {
  position: relative;
  width: 100%;
  //height: 180px;
  //background: bg_rgba(.5);
  overflow: hidden;
  transition: all 0.7s;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 360px;

  &::after {
    content: "";
    position: absolute;
    bottom: -12px;
    left: -2%;
    width: 104%;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1220;
    transform: skew(0, -3deg);
    transition: all 0.6s;
  }

  &::before {
    content: "";
    position: absolute;
    bottom: -12px;
    left: -2%;
    width: 104%;
    height: 30px;
    background-color: $grey_2;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    z-index: 1221;
    transform: skew(0, 2deg);
    transition: all 0.6s;
  }
}

.o-card_headerHeroImg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  transition: 0.4s;
  transform-origin: center center;
  transform: scale(1, 1);

  &::after {
    content: "";
    position: absolute;
    top: -20%;
    left: -20%;
    width: 140%;
    height: 140%;
    background: rgba(0, 0, 0, 1);
    transform: skew(0, 2deg);
    transition: 0.4s;
    opacity: 0;
  }
}

.o-card_logo {
  position: absolute;
  z-index: 2;
  width: 80px;
  height: 80px;
  //border: 1px solid $black;
  box-shadow: 2px 2px 1px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.5s;
  @include border-radius(50%);
  top: 10px;
  left: 10px;
  transform-origin: center center;
  transform: translate(0, 0) scale(1, 1);
  overflow: hidden;
  background-size: cover !important;

  &.isOpen {
    /*box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.5);*/
    //top: 40%;
    //transform: translate(0,0) scale(0.6, 0.6);
    //left: 90%;
    box-shadow: 0 0 0 800px rgba(255, 255, 255, 0.6);
    transform: translate(-140%, 0) scale(1, 1);
  }
}

.o-card:hover .o-card_logo {
  transform: translate(0, 0) scale(0.8, 0.8);
}

.o-card:hover .o-card_logo.isOpen {
  transform: translate(-140%, 0) scale(1, 1);
}

.o-card-headerList {
  width: 100%;
  height: auto;
  transition: all 0.4s;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 3;
  left: 0;
  top: 0;
  border-spacing: 5px;
  list-style: none;
}

.o-card-headerList--openIcons {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 40px;
  @include border-radius(4px);
  background: rgba(0, 0, 0, 0.3);
  z-index: 6;
  cursor: pointer;
  transition: all 0.4s;

  span {
    position: absolute;
    top: 0;
    left: 50%;
    margin: 0 0 0 -3px;
    width: 6px;
    height: 6px;
    background: $white;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    transition: all 0.8s;
    transform-origin: center;
    @include border-radius(50%);

    &:nth-child(1) {
      top: 6px;
    }

    &:nth-child(2) {
      top: 17px;
    }

    &:nth-child(3) {
      top: 28px;
    }
  }
}

.o-card-headerList.isOpen .o-card-headerList--openIcons {
  width: 40px;
  @include border-radius(50%);

  span {
    @include border-radius(0);
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0);
    margin: 0 0 0 -13px;
    top: 20px;

    &:nth-child(1) {
      width: 26px;
      height: 2px;
      transform: rotate(45deg);
    }

    &:nth-child(2) {
      opacity: 0;
      left: -250%;
    }

    &:nth-child(3) {
      width: 26px;
      height: 2px;
      transform: rotate(-45deg);
    }
  }
}

.o-card-headerList--item {
  width: 100px;
  height: 40px;
  transform: scale(0.15, 0.15);
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  @include border-radius(50%);
  transition: all 0.4s;
  opacity: 1;
  z-index: 5;
}

.o-card-headerList.isOpen .o-card-headerList--item {
  opacity: 1;
  transform: scale(1, 1);
}

.o-card-headerList--item:hover {
  color: white;
}

.itemColor {
  overflow-y: auto;
  max-height: 100px;
}

.o-card-headerList--link {
  background-color: #0d8ddc;
  color: $grey_5;
  border-radius: 100%;
  font-size: 1rem;
  transition: all 0.3s;

  &:hover {
    color: $white;
    transform: scale(1.2, 1.2);
  }
}

.o-card_body {
  width: 100%;
  height: auto;
  display: block;
  margin: -5px 0 0 0;
  padding: 0 30px 30px 30px;
  position: relative;
  background: $grey_2;
  transition: all 0.3s;
}

.o-card_title,
.o-card_subTitle {
  margin: 0;
  padding: 5px 0 5px 5px;
  border-bottom: 1px solid $grey_1;
  font-size: 1.2rem;
  font-weight: 400;
}

.o-card_title {
  font-size: 1.8rem;
  background: none;
  font-weight: 600;
  display: block;
}

.o-card_paragraph {
  margin: 0;
  padding: 5px;
  font-size: 0.9rem;
  line-height: 1.3;
  transition: all 0.4s;
  opacity: 1;
  position: relative;
  max-height: 3rem;
  overflow: hidden;

  &::after {
    content: "";
    width: 100%;
    max-height: 200rem;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3rem;
    background: -webkit-linear-gradient(
      90deg,
      $grey_2 0,
      hsla(0, 0%, 100%, 0) 100%
    );
    background: linear-gradient(0deg, $grey_2 0, hsla(0, 0%, 100%, 0) 100%);
  }

  &.isToggle {
    max-height: 200px;
    overflow-y: auto;

    &::after {
      background: none;
    }
  }
}

.a-more {
  color: $grey_3;
  font-weight: 700;
  font-size: 1.5rem;
  position: absolute;
  right: 10px;
  bottom: 25px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  // border-radius:50%;
  // background:rgba(255,255,255,0.5);
  cursor: pointer;
  transition: all 0.5s;

  &::after {
    content: "\2795";
    font-family: entypo;
  }

  &.isActive::after {
    content: "\2796";
  }

  &:hover {
    transform: scale(1.2, 1.2);
    color: $primary_color;
  }
}

.morecontent span {
  display: none;
}

.morelink {
  display: block;
}

.o-card {
  &.isOpen {
    .o-card_subTitle,
    .o-card_paragraph {
      display: block;
    }
  }

  &:hover {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1);

    .o-card_headerHeroImg {
      transform: scale(1.2) rotate(-2deg);
      opacity: 1;

      &::after {
        opacity: 0.4;
      }
    }
  }

  &.isOpen .o-card_header {
    height: 150px;
  }

  &:hover {
    // .o-card_header {
    //   height: 150px;
    // }
    // .o-card_logo {
    //   /*box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.5);*/
    //   top: 40%;
    //   transform: translate(0, 0) scale(0.6, 0.6);
    // }
  }

  &.isOpen {
    .o-card_headerHeroImg {
      transform: scale(1, 1);
      opacity: 1;
    }

    .o-card_logo {
      top: 10%;
      transform: translate(0, 0) scale(1, 1);
    }

    .o-card_header::before {
      //bottom: -30px;
    }

    &::before {
      width: 100%;
      left: 0;
    }
  }

  &:hover::before {
    width: 100%;
    left: 0;
  }
}

/*.o-card:hover .o-card_header::before { bottom: -38px;}
.o-card.isOpen .o-card-headerList{display: none;}
.o-card:hover .o-card-headerList{top: 0; transition-delay: .2s;}
.o-card.isOpen .o-card-headerList--item,
.o-card:hover .o-card-headerList--item{padding:10px 0;}*/

/*.o-card:hover .o-card_body{ height: 300px; box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);}*/
/*.o-card:hover::before{height: 100%; top: 0;}*/

@media screen and (min-width: 1200px) {
  h1 {
    font-size: 2.5rem;
  }
  //.a-container {
  //  width: 50%;
  //}
  //.o-card {
  //  width: 31.3333%;
  //  margin: 20px 1%;
  //}
  .o-card-headerList::before {
    bottom: -15px;
    border-width: 0 0 15px 400px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  h1 {
    font-size: 2rem;
  }
  .a-container {
    width: 100%;
  }
  .o-card {
    width: 48%;
    margin: 20px 1%;
  }
}

.o-card_footer {
  width: 100%;
  background: white;
  padding: 10px 10px 20px 10px;
  text-align: right;
  position: relative;
  display: inline-block;
  vertical-align: bottom;

  &::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 20px;
    background-color: $grey_1;
    z-index: 1;
    transform: skew(0, -2deg);
    transition: all 0.6s;
  }
}

.a-readMore {
  width: 100%;
  height: auto;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  color: $white;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  padding: 15px 0;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  position: relative;
  cursor: pointer;
  z-index: 3;
  border: none;
  background: #109bce;
  transition: all 0.5s;

  &:hover,
  &:active {
    top: 0;
  }
}

.o-wtfModal {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: -300px;
  opacity: 1;
  background: url(https://s3.eu-west-2.amazonaws.com/pirolab/images/circle.svg)
    no-repeat;
  background-position: center -10px;
  background-size: 300px 300px;
  opacity: 0.5;
  z-index: 100000;
  transition: all 0.5s;
  display: none;

  &.isOpenIng {
    display: block;
  }

  &.isOpen {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 1;
    background-position: center center;
    background-size: 500% 500%;
  }
}

.o-wtfModal_close {
  position: fixed;
  top: 10px;
  right: 10px;
  width: 46px;
  height: 46px;
  text-align: center;
  font-size: 4rem;
  color: $primary_color;
  opacity: 0;
  transition: all 1s;
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    @include border-radius(2px);
    text-align: center;
    font-size: 4rem;
    background: $primary_color;
    transform: rotate(0) translate(0, -50%);
    transition: all 0.5s;
  }
}

@media screen and (min-width: 768px) {
  .o-wtfModal_close {
    width: 66px;
    height: 66px;
  }
}

.o-wtfModal.isOpen .o-wtfModal_close {
  opacity: 1;

  &::after {
    transform: rotate(-45deg);
    width: 100%;
  }

  &::before {
    transform: rotate(45deg);
    width: 100%;
  }

  &:hover {
    transform: scale(0.8, 0.8);
  }
}

.profTr {
  transition: all 0.4s;
  position: absolute;
  top: 0;
  left: 0;
}

@font-face {
  font-family: "entypo";
  src: url("https://s3.eu-west-2.amazonaws.com/pirolab/icons/entypo.eot");
  src: url("https://s3.eu-west-2.amazonaws.com/pirolab/icons/entypo.eot?#iefix")
      format("embedded-opentype"),
    url("https://s3.eu-west-2.amazonaws.com/pirolab/icons/entypo.woff")
      format("woff"),
    url("https://s3.eu-west-2.amazonaws.com/pirolab/icons/entypo.ttf")
      format("truetype"),
    url("https://s3.eu-west-2.amazonaws.com/pirolab/icons/entypo.svg#entypo")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: entypo;
  font-style: normal;

  /* font-size: 14px; */

  display: inline-block;
  width: 1.1em;
  margin-right: 0.1em;
  text-align: center;
}

.the-icons li {
  font-size: 14px;
  line-height: 24px;
  height: 24px;
}

.icon-cancel-circled:before {
  content: "\2716";
}

.icon-left:before {
  content: "\2b05";
}

.icon-plus-circled:before {
  content: "\2795";
}

.icon-minus-circled:before {
  content: "\2796";
}
</style>
